import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSampleWindow } from "@/hooks/useSampleWindow";

const SEEN_KEY = "hl_sample_expired_seen";

/**
 * One-shot modal that fires the moment the 30-min sample expires.
 * Dismissible — after that the normal upgrade nudges take over.
 */
export default function SampleExpiredModal() {
  const { expired, ready } = useSampleWindow();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!ready || !expired) return;
    try {
      if (localStorage.getItem(SEEN_KEY)) return;
      localStorage.setItem(SEEN_KEY, "1");
    } catch {
      /* ignore */
    }
    setOpen(true);
  }, [ready, expired]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="inline-flex items-center gap-2 text-primary mb-2">
            <Sparkles className="h-5 w-5" />
            <span className="text-xs font-mono uppercase tracking-wider">Sample complete</span>
          </div>
          <DialogTitle className="text-2xl">Time's up — nice run.</DialogTitle>
          <DialogDescription>
            You got the full hub for 30 minutes. From here, the free plan keeps you
            going at a slower pace. Upgrade any time for more credits, faster models,
            and the full library.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col sm:flex-row gap-2 mt-2">
          <Button variant="outline" onClick={() => setOpen(false)} className="sm:flex-1">
            Keep exploring free
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
              navigate("/pricing");
            }}
            className="sm:flex-1"
          >
            See plans
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}